import React, { type ReactNode } from 'react';
import ErrorBoundary from './ErrorBoundary';

interface SuspenseErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

export default function SuspenseErrorBoundary({ children, fallback }: SuspenseErrorBoundaryProps) {
  return (
    <ErrorBoundary>
      <React.Suspense fallback={fallback || <div>Loading...</div>}>
        {children}
      </React.Suspense>
    </ErrorBoundary>
  );
}
